import React from "react"

const Spacer = ({size}) => <div style={{height: `${size}px`}} />
export default Spacer